import React, { ChangeEvent, memo, useEffect, useRef, useState } from "react";
import { Button, Card, CardBody, Container } from "react-bootstrap";
import { CastType, IItemBase, IItemBaseVariant, IQueryExtract, IQuerySelectData } from "../../../component/solution/Interfaces";
import { useAuth } from "../../../contexts/AuthContext";
import { ArrowLeft, ChevronDown, ChevronUp, Download, FileText, ImageOff, Search, Upload, UploadCloud, X, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Pencil, FileTextIcon, Plus } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import ReactQuill , { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ShowErrorAlert from "../../../component/ShowErrorAlert";
import Editor from "@monaco-editor/react";
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor } from "@dnd-kit/core";
import { SortableContext, arrayMove, useSortable, rectSortingStrategy, horizontalListSortingStrategy} from "@dnd-kit/sortable";
import { SortableBaseProductImages } from "../../../component/draggable/SortableBaseProductImages";


export const Products: React.FC = () => {

    const { fetchData, uploadMultipleFiles, responseErrorMessage, showErrorAlert, setShowErrorAlert, setResponseErrorMessage }  = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const base = location.state?.base as IItemBase | undefined; 
    const queryExtractExportUrl: string = `${process.env.REACT_APP_BASE_URL}/${"extracts/download"}`;
    const queryExtractImportUrl: string = `${process.env.REACT_APP_BASE_URL}/${"extracts/upload"}`;
    const queryUrlSelect: string = `${process.env.REACT_APP_BASE_URL}/${"query/select/data?includeCount=true"}`;
    const publicAssetsUrl: string = `${process.env.REACT_APP_PUBLIC_ASSETS_URL}/`; 
    const fetchBaseProductActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/PRODUCT_BASE_ACTIONS/run`; 
    const fetchProductBaseChannelActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/PRODUCT_BASE_CHANNEL_ACTIONS/run`; 
    const fetchProductVaraintBatchActionsQueryUrl: string = `${process.env.REACT_APP_BASE_URL}/functions/PRODUCT_VARIANT_BATCH_ACTIONS/run`; 

    const defaultQueryState: IQuerySelectData = { appCode: "sa_stock", selectCode: "product_base_list", where: "", orderBy: "", pageNum: 0, pageSize: 100};    
    const [queryState, setQueryState] = useState<IQuerySelectData>(defaultQueryState);

    const defaultSearchState = { name: "", description: "", group_name: "", created: "", updated: ""};
    const [searchState, setSearchState] = useState<{ [key: string]: string }>(defaultSearchState);

    const [baseItems, setBaseItems] = useState<IItemBase[]>([]);

    const [viewMode, setViewMode] = useState<'default' | 'edit' | 'seo' | 'channels' | 'history'>('default'); 


    const [previewImages, setPreviewImages] = useState<string[]>([]);
    const [selectedResourceFiles, setSelectedResourceFiles] = useState<File[]>([]);
    const [channelView, setChannelView] = useState("channel one"); // default to one
    const [expandedColors, setExpandedColors] = useState<{ [key: string]: boolean }>({});

    const [carouselIndexes, setCarouselIndexes] = useState<Record<string, number>>({});
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [carouselStartIndex, setCarouselStartIndex] = useState(0);

    const [variantFilter, setVariantFilter] = useState<'open' | 'closed' | 'all'>('all');

    //handling the opening of the images modal
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [selectedImages, setSelectedImages] = useState<string[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<string>("");
    const [carouselBaseImagesIndex, setCarouselBaseImagesIndex] = useState(0);

    const [queryLineState, setQueryLineState] = useState<IQuerySelectData>({
      appCode: "sa_stock",
      selectCode: "product_variant_list",  
      where: "",
      orderBy: "",
      pageNum: 0,
      pageSize: 100,
     
    });

    //product_variant_channel -> on channels 
    //asset_list -> on images for assets 
    //in_stock_list -> all the product stock levels

 

    const [selectedBaseItem, setSelectedBaseItem] = useState<IItemBase | null>(null);
    const [selectedBaseItemVariant, setSelectedBaseItemVariant] = useState<IItemBaseVariant[] | null>(null);

    const [channelStatus, setChannelStatus] = useState<Record<string, boolean>>({
        "channel one": true,
        "channel two": false,
        "channel three": false,
        "channel four": true,
        "channel five": false,
    });
    

    //Pagination Settings 
    const [pageNumber, setPageNumber] = useState<number>(0); 
    const [pageSize, setPageSize] = useState<number>(100);   
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [totalPages, setTotalPages] = useState<number>(0);

    const [expandedLocations, setExpandedLocations] = useState<{ [id: string]: boolean }>({});

    //Form Data Settings 

    const [formDataNameAndDesc, setFormDataNameAndDesc] = useState<{
        id: string;
        name: string;
        group_name: string;
        description: string;
        product_base_assets: { id: string; url: string }[];
    }>({
        id: "",
        name: "",
        group_name: "",
        description: "",
        product_base_assets: [],
    });

    const [initialFormDataNameAndDesc, setInitialFormDataNameAndDesc] = useState<{
        name: string;
        group_name: string;
        description: string;
        product_base_assets: { id: string; url: string }[];
    }>({
        name: "",
        group_name: "",
        description: "",
        product_base_assets: [],
    });

    const [showSaveBanner, setShowSaveBanner] = useState<boolean>(false); 

    //states to handle row selections
    const [selectAllGlobal, setSelectAllGlobal] = useState(false);
    const [selectedRowIds, setSelectedRowIds] = useState<Set<string>>(new Set());


    const [isImportModalOpen, setIsImportModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const [hasLoadedEditor, setHasLoadedEditor] = useState(false);
    const [hasUserEdited, setHasUserEdited] = useState(false);

    const [language, setLanguage] = useState("html");
    const [theme, setTheme] = useState("vs-light");
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const [isProductImageModalOpen, setIsProductImageModalOpen] = useState(false);
    const [carouselIndex, setCarouselIndex] = useState(0);


    useEffect(() => {
      setHasLoadedEditor(true); // runs after first render
    }, []);


    useEffect(() => {
      if (base) {
        // console.log(`====== testing what i get through ========`);
        // console.log(base);
        // console.log(`=======================`);
        handleSelectedBaseItem(base);
     

      } else {
        setViewMode("default");
      }
    }, [location.key]);

    // useEffect(() => {
    //   setViewMode("default");
    // }, [location.key]);

    useEffect(() => {
        if(!base){
          if(viewMode === "default"){
            fetchBaseItems(); //fetch base items
            setSelectedBaseItem(null); //reset selected base item
            setCarouselIndexes({});
            setSelectedIndex(0);
            setCarouselStartIndex(0);
            setSelectedBaseItemVariant(null);
          }
        }
    }, [queryState, viewMode, base]);

   
     // Pagination updates
      useEffect(() => {
          setQueryState(prev => ({
              ...prev,
              pageNum: pageNumber,
              pageSize: pageSize,
          }));
      }, [pageNumber, pageSize]);



    useEffect(() => {
      const iframe = iframeRef.current;
      if (!iframe) return;
      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      if (!doc) return;

      let timeout: NodeJS.Timeout;

      const ensureBody = () => {
        if (!doc.body) {
          requestAnimationFrame(ensureBody);
          return;
        }

        let container = doc.getElementById("editor-content");
        if (!container) {
          container = doc.createElement("div");
          container.id = "editor-content";
          container.style.whiteSpace = "pre-wrap";
          doc.body.appendChild(container);
        }

        // Clear previous timeout if typing continues
        clearTimeout(timeout);

        // Wait 300ms after typing stops
        timeout = setTimeout(() => {
          container!.textContent = formDataNameAndDesc.description || "";
        }, 300);
      };

      ensureBody();

      return () => clearTimeout(timeout); // cleanup on unmount
    }, [formDataNameAndDesc.description]);



    const fetchBaseItems = () => {
        fetchData(queryUrlSelect, {method:"POST", body: JSON.stringify(queryState)}, processData );
    }


    const processData = (result: any) => {

        //console.log(result);

        const data: IItemBase[] = [];

        for (const key in result.data) {
            const item = result.data[key];
            data.push({ ...item.data, ...item.control, id: item.id});
        }

        setBaseItems(data);

        // Pagination 
        setPageSize(pageSize);
        setTotalRecords(result?.numRecords);
        setTotalPages(Math.ceil(result?.numRecords / pageSize));

    }


    const processLineData = (result: any) => {

        const data: IItemBaseVariant[] = [];

        for (const key in result.data) {
            const item = result.data[key];
            data.push({ ...item.data, ...item.control, id: item.id});
        }

        //Set variants in selectedBaseItemVariant
        setSelectedBaseItemVariant(data);
    }


  const handleSelectedBaseItem = ( item: IItemBase) => {

       console.log(`we are here..... `, item); 
      //return is item is missing. 
      if (!item) return;


      // console.log(`we are here two ..... `); 

      // clearSearchClicked();
      // setPageNumber(0); 
      // setPageSize(100);   
      // setTotalRecords(0);
      // setTotalPages(0);

      //set selected base item. 
      setSelectedBaseItem(item);

      // Set form data from item
      const newFormData = { 
        id: item.id || "", 
        name: item.name || "", 
        group_name: item.group_name || "", 
        description: item.description || "", 
        product_base_assets: item.product_base_assets || []};

      setFormDataNameAndDesc(newFormData);
      setInitialFormDataNameAndDesc(newFormData); 

      const { pageNum, pageSize, ...rest } = queryLineState;

      const updatedQueryState: IQuerySelectData = {
        ...rest,
        where: `product_base_id = '${item.id}'`,
        params: { id: `${item.id}` }
      };
      

      fetchData(queryUrlSelect, { method: "POST", headers: { "Content-Type": "application/json"}, body: JSON.stringify(updatedQueryState)}, processLineData);
      setViewMode("edit"); 

  }


  const handleSearchOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    setSearchState((prev) => ({ ...prev, [id]: value }));
  };

  const handleViewImages = (images: { url: string }[]) => {
    setSelectedImages(images.map((img) => img.url));
    setIsImageModalOpen(true);
  };


  const handleRowToggle = (rowId: string) => {
      setSelectedRowIds(prev => {
        const updated = new Set(prev);
        if (updated.has(rowId)) {
          updated.delete(rowId);
        } else {
          updated.add(rowId);
        }
        return updated;
      });
  };

  const handleToggleAll = () => {
    const newSelectAll = !selectAllGlobal;
    setSelectAllGlobal(newSelectAll);
    setSelectedRowIds(new Set()); // reset any manual overrides
  };




    const generateWhereClause = (search: { [key: string]: string }) => {
        const clauses = Object.entries(search)
          .filter(([_, value]) => value.trim() !== "")
          .map(([key, value]) => {
            const sanitizedValue = value.replace(/'/g, "''");

            return `${key} ILIKE '%${sanitizedValue}%'`;
          });

      return clauses.join(" AND ");
    };


   const searchClicked = () => {
        // Reset pagination state
        setPageNumber(0); // Reset page to first page
        setPageSize(100); // Reset page size to 100

        // Reset selection state
        setSelectAllGlobal(false);
        setSelectedRowIds(new Set());

        const whereClause = generateWhereClause(searchState);

        setQueryState(prev => ({
        ...prev,
        where: whereClause,
        pageNum: 0, // Ensure that the query state reflects the reset page number
        pageSize: 100, // Ensure the query state reflects the reset page size
        }));
    };

   
   const clearSearchClicked = () => {
       setSearchState(defaultSearchState);
       setQueryState(defaultQueryState);
    }    
   

   // Pagination handlers
    const goToFirstPage = () => setPageNumber(0);
    const goToPreviousPage = () => setPageNumber(prev => prev - 1);
    const goToNextPage = () => setPageNumber(prev => prev + 1);
    const goToLastPage = () => setPageNumber(totalPages - 1);

    // Update page size handler
    const handlePageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
    };
                
   // Fields used for rendering the column-specific search inputs in the table header
    const searchFields = [
        // { name: 'channels', placeholder: 'Search Channels...' },
        { name: 'name', placeholder: 'Search Name...' },
        { name: 'group_name', placeholder: 'Search Group Name...'}, 
    ];
      

    // Column headers used to render the table column labels in the main table head
    const columnHeaders = [
        { key: 'images', label: 'Image' },
        { key: 'channels', label: 'Channels' },
        { key: 'name', label: 'Name' },
        { key: 'group_name', label: 'Group Name' },
        { key: 'actions', label: 'Actions' },
    ];



    function slugifyNameForUrl(name: string): string {
      return name
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')           // replace spaces with -
        .replace(/[^a-z0-9\-]/g, '')    // remove non-URL-safe characters
        .replace(/\-+/g, '-');          // collapse multiple dashes
    }


    const filteredVariants = selectedBaseItemVariant?.filter((variant) => {
      if (variantFilter === 'all') return true;
      if (variantFilter === 'open') return !variant.is_closed;
      if (variantFilter === 'closed') return variant.is_closed;
      return true;
   });


    const images = selectedBaseItem?.product_base_assets || [];
    const visibleImages = images.slice(carouselStartIndex, carouselStartIndex + 4);
    const canScrollLeft = carouselStartIndex > 0;
    const canScrollRight = carouselStartIndex + 4 < images.length;


    const toggleChannel = (key: string) => {
      setChannelStatus((prev) => ({
        ...prev,
        [key]: !prev[key],
      }));
    };


  // const handleOnChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | string, source: string, fieldName?: string) => {
  //     // Determine value and name
  //     const isQuill = typeof e === "string";
  //     const name = isQuill ? fieldName || "description" : e.target.name;
  //     const value = isQuill ? e : e.target.value;
  //     const trimmedValue = typeof value === "string" ? value.trimStart() : value;

  //     if (source === "name&description") {
  //       const updated = { ...formDataNameAndDesc, [name]: trimmedValue };
  //       setFormDataNameAndDesc(updated);

  //       // Compare to original
  //       const isChanged =
  //         updated.name !== initialFormDataNameAndDesc.name ||
  //         updated.group_name !== initialFormDataNameAndDesc.group_name ||
  //         updated.description !== initialFormDataNameAndDesc.description;

  //       setShowSaveBanner(isChanged);
  //     }
  //   };

  
  //check to determine if the form data has changed. 
  const checkIfChanged = ( updatedFormData = formDataNameAndDesc, initialData = initialFormDataNameAndDesc) => {

    const formChanged =
      updatedFormData.name !== initialData.name ||
      updatedFormData.group_name !== initialData.group_name ||
      updatedFormData.description !== initialData.description;

    const imagesChanged = 
      JSON.stringify(updatedFormData.product_base_assets.map((i) => i.id)) !== 
      JSON.stringify(initialData.product_base_assets.map((i) => i.id));

    return formChanged || imagesChanged;
  };
  
  const handleOnChange = ( value: string | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, source: string, fieldName?: string) => {
    const isQuill = typeof value === "string";
    const name = isQuill ? fieldName || "description" : value.target.name;
    const val = isQuill ? value : value.target.value;

    const updated = { ...formDataNameAndDesc, [name]: val };
    setFormDataNameAndDesc(updated);

    if (!hasUserEdited) setHasUserEdited(true);
    setShowSaveBanner(checkIfChanged(updated, initialFormDataNameAndDesc));
  };

  // const handleOnChange = (value: string | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, source: string, fieldName?: string) => {
  //   const isQuill = typeof value === "string";
  //   const name = isQuill ? fieldName || "description" : value.target.name;
  //   const val = isQuill ? value : value.target.value;

  //   const updated = { ...formDataNameAndDesc, [name]: val };
  //   setFormDataNameAndDesc(updated);

  //   if (source === "name&description") {
  //     // Only start checking after user edits
  //     if (!hasUserEdited) {
  //       setHasUserEdited(true);
  //       return;
  //     }

  //     const isChanged =
  //       updated.name !== initialFormDataNameAndDesc.name ||
  //       updated.group_name !== initialFormDataNameAndDesc.group_name ||
  //       updated.description !== initialFormDataNameAndDesc.description;

  //     if (isChanged !== showSaveBanner) {
  //       setShowSaveBanner(isChanged);
  //     }
  //   }
  // };


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files && e.target.files[0]) {
        setSelectedFile(e.target.files[0]);
      } else {
        setSelectedFile(null);
      }
  };


  const handleClearBanner = () => {
      const emptyForm = { id: "", name: "", group_name: "", description: "",  product_base_assets: [] };
      setFormDataNameAndDesc(emptyForm);
      setInitialFormDataNameAndDesc(emptyForm);
      setShowSaveBanner(false);
      setHasUserEdited(false); // crucial
      setLanguage("html"); // reset language
      setTheme("vs-light");     // reset theme

      // Optional: reset iframe content
      if (iframeRef.current) {
        iframeRef.current.src = iframeRef.current.src; // reloads the iframe
      }
  };

  const handleBackToProductsReset = () => {
      handleClearBanner();
      setViewMode("default");
      setExpandedColors({});
      setPreviewImages([]);
      setSelectedResourceFiles([]);
      setVariantFilter("all");
      setCarouselIndexes({});
      setSelectedIndex(0);
      setCarouselStartIndex(0);
      setLanguage("html"); // reset language
      setTheme("vs-light");     // reset theme

      // Optional: reset iframe content
      if (iframeRef.current) {
        iframeRef.current.src = iframeRef.current.src; // reloads the iframe
      }
    };

    useEffect(() => {
      console.log(showSaveBanner);
    } , [showSaveBanner])
   



    // ============================
    // Handling Edit Product Data
    // ============================

  

    //handle base product name, group name and description discard changes
    const handleProductTextInformationDiscard = () => {
      setFormDataNameAndDesc((prev) => ({
        ...prev,
        name: initialFormDataNameAndDesc.name,
        group_name: initialFormDataNameAndDesc.group_name,
        description: initialFormDataNameAndDesc.description,
        product_base_assets: initialFormDataNameAndDesc.product_base_assets
      }));

      setShowSaveBanner(false); 

      setLanguage("html"); // reset language
      setTheme("vs-light");     // reset theme

      // Optional: reset iframe content
      if (iframeRef.current) {
          iframeRef.current.src = iframeRef.current.src; // reloads the iframe
      }
    }



  const handleProductTextInformation = () => {
    if (formDataNameAndDesc.name === "") return;

    const { product_base_assets, ...rest } = formDataNameAndDesc;

    const payload = {
      ...rest, // everything except product_base_assets
      name: rest.name.trim(),
      group_name: rest.group_name?.trim() ?? "",
      description: rest.description?.trim() ?? "",
      asset_ids: product_base_assets.map(asset => asset.id), // only ids
    };


    // local flag scoped to this single request
    let callbackCalled = false;

    fetchData(
      fetchBaseProductActionsQueryUrl,
      { method: "PUT", body: JSON.stringify(payload) },
      // processData callback
      (result: any, status: string) => {
        callbackCalled = true; // <- mark that processData ran for this call

        if (status === "200" && selectedBaseItem) {
            handleClearBanner();

          // re-fetch base items
          // fetchData(queryUrlSelect, { method: "POST", body: JSON.stringify(queryState) }, (result: any) => {
          //   const updatedBaseItems: IItemBase[] = [];
          //   for (const key in result.data) {
          //     const item = result.data[key];
          //     updatedBaseItems.push({ ...item.data, ...item.control, id: item.id });
          //   }
          //   const updatedItem = updatedBaseItems.find(item => item.id === selectedBaseItem.id);
          //   if (updatedItem) handleSelectedBaseItem(updatedItem);
          // });

            const { ...rest } = queryState;
            const updatedQueryState: IQuerySelectData = { ...rest, where: `id = :id`, params: { id: `${selectedBaseItem?.id}` }};

            fetchData(queryUrlSelect, { method: "POST", body: JSON.stringify(updatedQueryState) }, (result: any) => {

              if (result?.data?.length) {
                  const itemData = result.data[0].data;

                  // Map it to IItemBase
                  const selectedItem: IItemBase = {
                      id: result.data[0].id,
                      created: result.data[0].control.created,
                      updated: result.data[0].control.updated,
                      dirty: result.data[0].control.dirty,
                      touched: result.data[0].control.touched,
                      name: itemData.name,
                      description: itemData.description,
                      group_name: itemData.group_name,
                      opts: itemData.opts,
                      product_base_assets: itemData.product_base_assets || [],
                      product_variants: itemData.product_variants || [],
                      is_closed: itemData.is_closed,
                      channels: itemData.channels || [],
                      num_variants: itemData.num_variants,
                      slug: itemData.slug
                  };

                  setSelectedBaseItem(selectedItem); 


                  // Set form data from item
                  const newFormData = { 
                    id: selectedItem.id || "", 
                    name: selectedItem.name || "", 
                    group_name: selectedItem.group_name || "", 
                    description: selectedItem.description || "", 
                    product_base_assets: selectedItem.product_base_assets || []
                  };

                  setFormDataNameAndDesc(newFormData);
                  setInitialFormDataNameAndDesc(newFormData); 
              }
            });


        } else {
          console.log("did we get into here....");
          handleProductTextInformationDiscard();
        }
      },
      // clean callback — always called (finally). Use it to handle the case where processData was never called.
      () => {
        if (!callbackCalled) {
          // processData never ran for this request -> treat as failure
          console.log("Request failed before processData ran (network or non-OK).");
          handleProductTextInformationDiscard();
        }
        // otherwise do nothing: processData already handled success/failure logic
      }
    );
  };

 

  const cellStyle = {
    border: "none",
    padding: "0.75rem 0.5rem 0.75rem 1.2rem",
    verticalAlign: "middle",
    backgroundColor: "transparent",
  };

  const cellStyleImage = {
    border: "none",
    padding: "0.75rem 0.5rem 0.75rem 1.9rem",
    verticalAlign: "middle",
    backgroundColor: "transparent",
  };


  const defaultTdStyle = {
    padding: "0.5rem",        // same as 8px
    border: "none",
    verticalAlign: "middle",     // default for <td>
    backgroundColor: "white", // or transparent depending on context
  };


    const currentPageIds = baseItems.map(row => row.id);
    
    const allCurrentPageSelected = selectAllGlobal
      ? currentPageIds.every(id => !selectedRowIds.has(id)) 
      : currentPageIds.every(id => selectedRowIds.has(id));

    const exportProductVariantQuery: IQueryExtract = {
            sheetName: "",
            queryCreate: { 
              tableName: "sa_product_base",
              select: [{ fullColumnName: "id", aggregate: "" },
                       { fullColumnName: "name", aggregate: "" }, 
                       { fullColumnName: "group_name", aggregate: "" }],
              groupBy: [],
              join: [],
              orderBy: [ 
                  {
                      fullColumnName: "name",
                      direction: "ASC",
                      cast: CastType.STRING
                  }
              ],
              where:[],
              mainTableOnly: false,
              includeExtraColumns: true,
              includeControlColumns: true,
              modifiedAfter: null,
              touchedBefore: null,
              isDirty: null,
              frontEndOnly: null,
              idSelect: null
          } 
    }

   
    const handleProductVariantExport = () => {
        const allSelectedIds = Array.from(selectedRowIds); // could be empty
        const whereConditions: typeof exportProductVariantQuery.queryCreate.where = [];

        // Step 1: Include search filters
        Object.entries(searchState).forEach(([key, rawValue]) => {
          const value = rawValue.trim();
          if (value === "") return;
            const sanitized = value.replace(/'/g, "''");
            whereConditions.push({
              fullColumnName: key,
              operator: "ILIKE",
              value: `%${sanitized}%`,
            });
         });
  
        // Step 2: Handle row selection logic
        if (selectAllGlobal) {
          if (allSelectedIds.length > 0) {
            // Select All is active but user deselected some → exclude them
            whereConditions.push({
              fullColumnName: "id",
              value: allSelectedIds,
              operator: "IN",
              not: true,
            });
          }
          // else: everything selected, no exclusion needed
        } else {
          if (allSelectedIds.length > 0) {
            // User selected specific rows → include only those
            whereConditions.push({
              fullColumnName: "id",
              value: allSelectedIds,
              operator: "IN",
              not: false,
            });
          } else {
             // Nothing selected manually → export everything that matches search filters
             // So we leave `whereConditions` as is (only search filters)
              console.log("Do nothing");
          }
        }
  
        const exportName = `p_list`;
        
      
        // Finalize export query
        const finalExportQuery: IQueryExtract = {
          ...exportProductVariantQuery,
          sheetName: exportName,
          queryCreate: {
            ...exportProductVariantQuery.queryCreate,
            where: whereConditions
          },
        };
  
        //console.log("Final Export Query:", finalExportQuery);
        
        fetchData(queryExtractExportUrl, 
          {method:"POST", body: JSON.stringify(finalExportQuery)}, 
          (result: any, status: string) => {
              if(status === "200" || status === "201"){
                  productVaraintExcelList(result);
              }
          });
    };

    const productVaraintExcelList = async (result: any) => {
        const now = new Date();
        const timestamp = now.toISOString().replace(/[:.]/g, "-").replace("T", "_").replace("Z", "");
        const fileName = `p_list_${timestamp}.xlsx`;

        // Create a download link for the Blob
        const url = URL.createObjectURL(result);
        // Create a temporary <a> element to trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // Set the default filename here
        document.body.appendChild(a);
        a.click();
    } 

    const handleFileImportSubmit = () => {
        if (!selectedFile) return;

          // how to do a multipe part form posts javascript  
          const formData = new FormData();
          formData.append('file', selectedFile);
          
          const headers = new Headers();
          headers.append("Content-Type", "multipart/formdata"); 

          
          fetchData(queryExtractImportUrl, 
            {method:"POST", body: formData, headers: headers }, 
            (result: any, status: string) =>  { 
              if(status === "200"){
                  //we will have to refect all the products 
                  setSelectAllGlobal(false);
                  setSelectedRowIds(new Set());
                  fetchBaseItems();
              }
            });

        // Optional: Reset and close modal
        setSelectedFile(null);
        setIsImportModalOpen(false);
    };


    const getChannelColor = (code: string) => {
      const baseColors: Record<string, string> = {
        AMAZON: '#FF9900',
        SHOPIFY: '#96BF48',
        TAKEALOT: '#0075B8',
        GOOGLE: '#4285F4',
        WOOCOMMERCE: '#96588A',
        POS: '#2b4a8c',
      };

      return baseColors[code.toUpperCase()] || '#ccc';
    };



 


  const handleSubmitResourceFiles = async () => {
  
      if (!selectedResourceFiles || selectedResourceFiles.length === 0) return;

      const jsonPayload = { product_base_id : selectedBaseItem?.id ?? "" };
      const results = await uploadMultipleFiles( selectedResourceFiles, jsonPayload,`${process.env.REACT_APP_BASE_URL}/functions/PRODUCT_BASE_ASSET_ACTIONS/run`);

      const failed = results.filter((r) => !r.success);
      const succeeded = results.filter((r) => r.success);

      if (succeeded.length > 0) {
          console.log("Successfully uploaded:", succeeded.map((r) => r.fileName));
          setPreviewImages([]);
          setSelectedResourceFiles([]);

          const { ...rest } = queryState;
          const updatedQueryState: IQuerySelectData = { ...rest, where: `id = :id`, params: { id: `${selectedBaseItem?.id}` }};

          fetchData(queryUrlSelect, { method: "POST", body: JSON.stringify(updatedQueryState) }, (result: any) => {

              if (result?.data?.length) {
                const itemData = result.data[0].data;

                // Map it to IItemBase
                const selectedItem: IItemBase = {
                    id: result.data[0].id,
                    created: result.data[0].control.created,
                    updated: result.data[0].control.updated,
                    dirty: result.data[0].control.dirty,
                    touched: result.data[0].control.touched,
                    name: itemData.name,
                    description: itemData.description,
                    group_name: itemData.group_name,
                    opts: itemData.opts,
                    product_base_assets: itemData.product_base_assets || [],
                    product_variants: itemData.product_variants || [],
                    is_closed: itemData.is_closed,
                    channels: itemData.channels || [],
                    num_variants: itemData.num_variants,
                    slug: itemData.slug
                };

                setSelectedBaseItem(selectedItem); 

                // Set form data from item
                const newFormData = { 
                  id: selectedItem.id || "", 
                  name: selectedItem.name || "", 
                  group_name: selectedItem.group_name || "", 
                  description: selectedItem.description || "", 
                  product_base_assets: selectedItem.product_base_assets || []
                };

                  setFormDataNameAndDesc(newFormData);
                  setInitialFormDataNameAndDesc(newFormData); 
     
              }
          });
      }
      if (failed.length > 0) {
          console.error( "Failed uploads:", failed.map((r) => `${r.fileName} (status: ${r.status})`));
          setPreviewImages([]);
          setSelectedResourceFiles([]);
          setResponseErrorMessage(`Failed to upload: ${failed.map((r) => r.fileName).join(", ")}`);
          setShowErrorAlert(true);
      }
  };


    /* 


    //https://dev-server.stockanywhere.co.za/public/assets

    //Retrieve resources

    /public/assets/foo/Screenshot from 2023-07-03 08-27-08.png

    */


    // handle navigate to select product variant. 
    const handleNavigateToProductVariant = (variant : IItemBaseVariant, base: IItemBase) => {
        
        console.log(`selected variant: `, variant);
        console.log(`selected base`, base); 

        navigate("/product_variants", { state: { variant: variant , base: base } });
    }


    // sensors for drag and drop minimul 5px movement
    const sensors = useSensors(
      useSensor(PointerSensor, {
        activationConstraint: {
          distance: 5, // require small movement to start drag
        },
      })
    );


    const handleDragEnd = (event: any) => {
      const { active, over } = event;
      if (!over || active.id === over.id) return;

      setFormDataNameAndDesc((data) => {
        const oldIndex = data.product_base_assets.findIndex((i) => i.id === active.id);
        const newIndex = data.product_base_assets.findIndex((i) => i.id === over.id);
        const updatedAssets = arrayMove(data.product_base_assets, oldIndex, newIndex);

        const updated = { ...data, product_base_assets: updatedAssets };

        if (!hasUserEdited) setHasUserEdited(true);
        setShowSaveBanner(checkIfChanged(updated, initialFormDataNameAndDesc));

        return updated;
      });
    };



    
    const handleRemoveProductBaseImage = (product_base_id: string, asset_id: string) => {

       // return early if either ID is empty
       if (!product_base_id || !asset_id) return;
    
        const postData = { product_base_id: product_base_id, asset_id: asset_id}

        fetchData(`${process.env.REACT_APP_BASE_URL}/functions/PRODUCT_BASE_ASSET_ACTIONS/run`, 
        { method: "DELETE", body: JSON.stringify(postData) }, 
        (result: any, status: string) => {
          if(status === "200"){

            const { ...rest } = queryState;
            const updatedQueryState: IQuerySelectData = { ...rest, where: `id = :id`, params: { id: `${selectedBaseItem?.id}` }};

            fetchData(queryUrlSelect, { method: "POST", body: JSON.stringify(updatedQueryState) }, (result: any) => {

              if (result?.data?.length) {
                  const itemData = result.data[0].data;

                  // Map it to IItemBase
                  const selectedItem: IItemBase = {
                      id: result.data[0].id,
                      created: result.data[0].control.created,
                      updated: result.data[0].control.updated,
                      dirty: result.data[0].control.dirty,
                      touched: result.data[0].control.touched,
                      name: itemData.name,
                      description: itemData.description,
                      group_name: itemData.group_name,
                      opts: itemData.opts,
                      product_base_assets: itemData.product_base_assets || [],
                      product_variants: itemData.product_variants || [],
                      is_closed: itemData.is_closed,
                      channels: itemData.channels || [],
                      num_variants: itemData.num_variants,
                      slug: itemData.slug
                  };

                  setSelectedBaseItem(selectedItem); 


                  // Set form data from item
                  const newFormData = { 
                    id: selectedItem.id || "", 
                    name: selectedItem.name || "", 
                    group_name: selectedItem.group_name || "", 
                    description: selectedItem.description || "", 
                    product_base_assets: selectedItem.product_base_assets || []
                  };

                  setFormDataNameAndDesc(newFormData);
                  setInitialFormDataNameAndDesc(newFormData); 
              }
            });
          }
      });
    };


  const handleToggleChannel = ( base_id: string, channel_id: string, is_enabled: boolean) => {

    if(base_id === "" || channel_id === "") return; 

    const payload = { 
          product_base_id: base_id,
          channel_id: channel_id,
          is_enabled: is_enabled
    } 
      
    // local flag to detect if processData was called
    let callbackCalled = false;

    
    fetchData(
      fetchProductBaseChannelActionsQueryUrl,
      { method: "PUT", body: JSON.stringify(payload)},
      (result: any, status: string) => {
        callbackCalled = true; // mark callback as called

        if (status === "200" && selectedBaseItem) {

            const { ...rest } = queryState;
            const updatedQueryState: IQuerySelectData = { ...rest, where: `id = :id`, params: { id: `${selectedBaseItem?.id}` }};

            fetchData(queryUrlSelect, { method: "POST", body: JSON.stringify(updatedQueryState) }, (result: any) => {

              if (result?.data?.length) {
                  const itemData = result.data[0].data;

                  // Map it to IItemBase
                  const selectedItem: IItemBase = {
                      id: result.data[0].id,
                      created: result.data[0].control.created,
                      updated: result.data[0].control.updated,
                      dirty: result.data[0].control.dirty,
                      touched: result.data[0].control.touched,
                      name: itemData.name,
                      description: itemData.description,
                      group_name: itemData.group_name,
                      opts: itemData.opts,
                      product_base_assets: itemData.product_base_assets || [],
                      product_variants: itemData.product_variants || [],
                      is_closed: itemData.is_closed,
                      channels: itemData.channels || [],
                      num_variants: itemData.num_variants,
                      slug: itemData.slug
                  };

                  setSelectedBaseItem(selectedItem); 


                  // Set form data from item
                  const newFormData = { 
                    id: selectedItem.id || "", 
                    name: selectedItem.name || "", 
                    group_name: selectedItem.group_name || "", 
                    description: selectedItem.description || "", 
                    product_base_assets: selectedItem.product_base_assets || []
                  };

                  setFormDataNameAndDesc(newFormData);
                  setInitialFormDataNameAndDesc(newFormData); 
              }
            });
          
        } else {
          console.log("Variant update failed (non-200 response)");
        }
      },
      // clean callback (runs on both success / failure) 
      () => {
        if (!callbackCalled) { //trigger on failure
          console.log("Request failed before processData ran (network or non-OK).");
        }
      }
    );
  }

  const handleEnablingProductVariantSelection = (product_base_id: string, channel_id: string, is_enabled: boolean) => {
    if(product_base_id === "" || channel_id === "") return; 

    const payload = { 
          product_base_id: product_base_id,
          channel_id: channel_id,
          is_enabled: is_enabled
    } 
      
    // local flag to detect if processData was called
    let callbackCalled = false;

    fetchData(
      fetchProductVaraintBatchActionsQueryUrl,
      { method: "PUT", body: JSON.stringify(payload)},
      (result: any, status: string) => {
        callbackCalled = true; // mark callback as called

        if (status === "200" && selectedBaseItem) {

            const { ...rest } = queryState;
            const updatedQueryState: IQuerySelectData = { ...rest, where: `id = :id`, params: { id: `${selectedBaseItem?.id}` }};

            fetchData(queryUrlSelect, { method: "POST", body: JSON.stringify(updatedQueryState) }, (result: any) => {

              if (result?.data?.length) {
                  const itemData = result.data[0].data;

                  // Map it to IItemBase
                  const selectedItem: IItemBase = {
                      id: result.data[0].id,
                      created: result.data[0].control.created,
                      updated: result.data[0].control.updated,
                      dirty: result.data[0].control.dirty,
                      touched: result.data[0].control.touched,
                      name: itemData.name,
                      description: itemData.description,
                      group_name: itemData.group_name,
                      opts: itemData.opts,
                      product_base_assets: itemData.product_base_assets || [],
                      product_variants: itemData.product_variants || [],
                      is_closed: itemData.is_closed,
                      channels: itemData.channels || [],
                      num_variants: itemData.num_variants, 
                      slug: itemData.slug
                  };

                  setSelectedBaseItem(selectedItem); 


                  // Set form data from item
                  const newFormData = { 
                    id: selectedItem.id || "", 
                    name: selectedItem.name || "", 
                    group_name: selectedItem.group_name || "", 
                    description: selectedItem.description || "", 
                    product_base_assets: selectedItem.product_base_assets || []
                  };

                  setFormDataNameAndDesc(newFormData);
                  setInitialFormDataNameAndDesc(newFormData); 
              }
            });
          
        } else {
          console.log("Variant update failed (non-200 response)");
        }
      },
      // clean callback (runs on both success / failure) 
      () => {
        if (!callbackCalled) { //trigger on failure
          console.log("Request failed before processData ran (network or non-OK).");
        }
      }
    );
  }


  const handleCloseAndResetModal = (from : string) => {
    if(from === "default-gallery"){
      setSelectedImages([]); 
      setIsImageModalOpen(false); 
      setCarouselBaseImagesIndex(0); 
      setSelectedProduct("");
    }

    if(from === "edit-gallery"){
      setIsProductImageModalOpen(false); 
      setCarouselIndex(0);
    }
  }

    return(
         <React.Fragment>
            { showErrorAlert && <ShowErrorAlert message={responseErrorMessage} /> } 
            <Container fluid className="p-0">
                 {viewMode === "default" && 
                 <Card>
                   <Card.Header style={{ padding: '15px 0px 0px 20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                      <Card.Title>Products</Card.Title>
                      <div className="d-flex gap-2 me-3">
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          title="Import Variants"
                          onClick={() => {
                            setIsImportModalOpen(true);
                          }}
                        >
                          <Upload size={16} />
                        </button>
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          title="Export Variants"
                          onClick={handleProductVariantExport}
                        >
                          <Download size={16} />
                        </button>
                      </div>
                    </div>
                  </Card.Header>
                  <CardBody>
                          <div>
                            <div style={{ width: '100%', padding: '4px 8px', backgroundColor: 'white' }}>
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row gap-2" style={{marginTop: '14px'}}>
                                            <h6 className="card-subtitle text-muted">Total Records: {totalRecords} </h6> 
                                            <h6 className="card-subtitle text-muted">Current Page :  [{ pageNumber + 1 } of {totalPages}]</h6> 
                                        </div>

                                        <div className="d-flex align-items-center gap-3">
                                            {/* // Page Size */}
                                            <nav aria-label="">
                                                <ul className="pagination m-0">
                                                    <li className="page-item">
                                                        <select className="page-link" 
                                                            value={pageSize}
                                                            onChange={handlePageSizeChange}
                                                            style={{width: '100px', textAlign: 'center', padding: '10px'}}>
                                                            <option defaultChecked value={pageSize}>{pageSize}</option>
                                                            {[25, 50, 75, 100, 150, 200, 250, 500, 750, 1000].map(size => (
                                                              <option key={size} value={size}>{size}</option>
                                                            ))}
                                                        </select>
                                                    </li>                            
                                                </ul>
                                            </nav>

                                            {/* // Pagination Control */}
                                             <nav aria-label="">
                                              <ul className="pagination m-0">
                                                <li className={`page-item ${pageNumber === 0 ? 'disabled' : ''}`}>
                                                  <button 
                                                    className="page-link d-flex align-items-center justify-content-center gap-1"
                                                    onClick={goToFirstPage}
                                                    disabled={pageNumber === 0}
                                                    style={{ height: '38px', marginTop: '1px' }}
                                                  >
                                                    <ChevronsLeft size={18} />
                                                  </button>
                                                </li>

                                                <li className={`page-item ${pageNumber <= 0 ? 'disabled' : ''}`}>
                                                  <button 
                                                    className="page-link d-flex align-items-center justify-content-center"
                                                    onClick={goToPreviousPage}
                                                    disabled={pageNumber <= 0}
                                                    style={{ height: '38px', marginTop: '1px' }}
                                                  >
                                                    <ChevronLeft size={18} />
                                                  </button>
                                                </li>

                                                <li className="page-item">
                                                  <span
                                                    className="page-link d-flex align-items-center justify-content-center"
                                                    style={{ height: '38px', marginTop: '1px', padding: '0 14px' }}
                                                  >
                                                    Page {pageNumber + 1} of {totalPages}
                                                  </span>
                                                </li>

                                                <li className={`page-item ${pageNumber >= totalPages - 1 ? 'disabled' : ''}`}>
                                                  <button 
                                                    className="page-link d-flex align-items-center justify-content-center"
                                                    onClick={goToNextPage}
                                                    disabled={pageNumber >= totalPages - 1}
                                                    style={{ height: '38px', marginTop: '1px' }}
                                                  >
                                                    <ChevronRight size={18} />
                                                  </button>
                                                </li>

                                                <li className={`page-item ${pageNumber >= totalPages - 1 ? 'disabled' : ''}`}>
                                                  <button 
                                                    className="page-link d-flex align-items-center justify-content-center gap-1"
                                                    onClick={goToLastPage}
                                                    disabled={pageNumber >= totalPages - 1}
                                                    style={{ height: '38px', marginTop: '1px' }}
                                                  >
                                                    <ChevronsRight size={18} />
                                                  </button>
                                                </li>
                                              </ul>
                                            </nav>
                                        </div>
                                </div>
                            </div>
                            <div className="table-responsive">
                            <table className="table table-md table-hover-light w-100 mb-0">
                                {/* FILTER INPUTS HEADER */}
                                <thead>
                                  <tr>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}></th> 
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}></th>
                                    <th style={{ backgroundColor: 'white', margin:'0px', padding: '4px 8px' }}></th>
                                     { searchFields.map(({ name, placeholder }) => (
                                         <td key={name} style={{ backgroundColor: 'white', padding: '4px 8px' }}>
                                          <input id={name} name={name} value={searchState[name] ?? ''} onChange={handleSearchOnChange} type="text" autoComplete="off"  placeholder={placeholder} className="form-control form-control-md" />
                                        </td>
                                    ))}
                                    <th style={{ backgroundColor: 'white', padding: '4px 8px', width:'120px' }}>
                                         <div className="d-flex justify-content-end gap-1 w-100">
                                          <button
                                            type="button"
                                            className="btn btn-outline-danger btn-md d-flex justify-content-center align-items-center"
                                            onClick={searchClicked}
                                          >
                                            <Search style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-outline-secondary btn-md d-flex justify-content-center align-items-center"
                                            onClick={clearSearchClicked}
                                          >
                                            <X style={{ width: '20px', height: '20px' }} strokeWidth={2} />
                                          </button>
                                        </div>
                                    </th>
                                  </tr>
                                </thead>
                                <thead>
                                <tr>
                                  <td
                                    style={{
                                      fontWeight: "600",
                                      backgroundColor: "white",
                                      border: 'none',
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "40px", // Set a consistent height for the checkbox
                                    }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={currentPageIds.length > 0 && allCurrentPageSelected}
                                      onChange={handleToggleAll}
                                    />
                                  </td>
                                  {columnHeaders.map(({ key, label }, index) => (
                                    <th
                                      key={key}
                                      style={{
                                        fontWeight: "600",
                                        backgroundColor: "white",
                                        paddingLeft: "20px",
                                        height: "40px", // Make sure all header cells have the same height
                                        ...(index === columnHeaders.length - 1 && { borderRight: "1px solid #deebed" }),
                                      }}
                                    >
                                      {label}
                                    </th>
                                  ))}
                                </tr>
                            </thead>
                                <tbody>
                        
                                   {baseItems.map((record, index) => {

                                    const { id, name, product_base_assets, group_name, channels } = record;
                                    const cellStyle: React.CSSProperties = { whiteSpace: 'nowrap', padding: '4px 6px', fontSize: '0.75rem', verticalAlign: 'middle', borderRight: 'none', borderLeft: 'none', borderTop:'1px solid #deebed', borderBottom:'1px solid #deebed' };
                                    const isRowChecked = selectAllGlobal ? !selectedRowIds.has(record.id) : selectedRowIds.has(record.id); // explicitly selected
                                    return (
                                           <tr id={`${index}`} key={id}>
                                               <td style={{ ...cellStyle, textAlign: 'center', padding: '0' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60px', paddingBottom: '4px' }}>
                                                  <input
                                                    type="checkbox"
                                                    checked={isRowChecked}
                                                    className="form-check-input"
                                                    onChange={() => handleRowToggle(id)}
                                                  />
                                                </div>
                                              </td>
                                              <td style={cellStyle}>
                                              <div className="table-image-container"
                                                style={{ position: 'relative', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40px', maxHeight: '60px', overflow: 'hidden', boxShadow: 'none' }}
                                                onMouseEnter={(e) => {
                                                  const icon = e.currentTarget.querySelector('.hover-search-icon') as HTMLDivElement;
                                                  if (icon) icon.style.opacity = '1';
                                                }}
                                                onMouseLeave={(e) => {
                                                  const icon = e.currentTarget.querySelector('.hover-search-icon') as HTMLDivElement;
                                                  if (icon) icon.style.opacity = '0';
                                                }}
                                              >
                                                {Array.isArray(product_base_assets) && product_base_assets.length > 0 ? (
                                                  <>
                                                    <img src={`${publicAssetsUrl}${product_base_assets[0].url}`} alt={name} title={name} //
                                                      style={{ maxHeight: '40px', maxWidth: '100%', borderRadius: '4px', objectFit: 'contain', display: 'block'}}
                                                      onClick={() => handleSelectedBaseItem(record)}
                                                      onError={(e) => (e.currentTarget.style.display = 'none')}
                                                    />

                                                    <div
                                                      className="hover-search-icon"
                                                      style={{opacity: 0,transition: 'opacity 0.2s ease', position: 'absolute', top: '0px', right: '0px', cursor: 'pointer', zIndex: 10}}
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleViewImages(product_base_assets);
                                                        setSelectedProduct(name);
                                                      }}
                                                    >
                                                      <Search size={16} color="#555" />
                                                    </div>
                                                  </>
                                                ) : (
                                                  <div style={{width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                    onClick={() => handleSelectedBaseItem(record)}
                                                  >
                                                    <ImageOff size={24} color="#ccc" />
                                                  </div>
                                                )}
                                              </div>
                                            </td>
                                              <td style={{ ...cellStyle, paddingLeft: '21px' }}>
                                                {Array.isArray(channels) && channels.length > 0 ? (
                                                  <div style={{ display: 'flex', gap: '6px', flexWrap: 'nowrap', overflow: 'hidden' }}>
                                                    {channels.slice(0, 5).map(channel => (
                                                      <span
                                                        key={channel.id}
                                                        title={`${channel.code}`}
                                                        style={{
                                                          width: '12px',
                                                          height: '12px',
                                                          borderRadius: '50%',
                                                          backgroundColor: channel.is_enabled ? getChannelColor(channel.code) : 'white',
                                                          border: `2px solid ${getChannelColor(channel.code)}`,
                                                          flexShrink: 0
                                                        }}
                                                      />
                                                    ))}
                                                    {channels.length > 5 && (
                                                      <span style={{ whiteSpace: 'nowrap' }}>…</span>
                                                    )}
                                                  </div>
                                                ) : null}
                                              </td>

                                              <td style={{...cellStyle, paddingLeft: '20px'}} title={name}>
                                                  {name}
                                              </td>
                                              <td style={{...cellStyle, paddingLeft: '20px'}} title={group_name ?? ""}>
                                                  {group_name ?? ""}
                                              </td>
                                              <td style={cellStyle} >   
                                                <button className="btn btn-outline-secondary btn-sm pt-1 pb-1 d-flex align-items-center gap-1 rounded" title="Edit"
                                                    onClick={() => handleSelectedBaseItem(record)}
                                                  >
                                                      <Pencil size={16} />
                                                  </button>
                                              </td> 
                                            </tr>
                                    );
                                  })}
                                    
                                </tbody>
                              </table>
                              </div>
                            </div>
                  </CardBody>
                </Card>
                }


              { viewMode !== "default" && 
                 <> 
               
                 <Card>
                   <Card.Header style={{ padding: "15px 20px 0px 20px", position: "relative", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <button className="custom-back-btn" title="Back To Products" onClick={handleBackToProductsReset}> 
                          <X className="back-btn-svg" size={18}  /> 
                        </button>
                        <Card.Title style={{ margin: 0 }}>Product Base View</Card.Title>
                      </div>
                      {showSaveBanner && (
                        <div className="save-banner">
                            <span className="save-message">You have unsaved changes:</span>
                            <button className="banner-buttons" onClick={handleProductTextInformation}>
                                <span>Save</span>
                            </button>
                            <button className="banner-buttons" onClick={handleProductTextInformationDiscard}>
                                <span>Discard</span>
                            </button>
                        </div>
                      )}
                    </Card.Header>



                  
                   <Card.Body style={{ backgroundColor: "#f5f7fa", borderRadius: "0 0 0.5rem 0.5rem", margin:'10px 4px 4px 4px', border:'1px solid #e1e5ec'}}>
                    <div className="d-flex border-bottom mb-4" style={{ gap: '1rem' }}>
                     {[
                        { key: 'edit', label: 'Edit Product' },
                        { key: 'seo', label: 'SEO Settings', disabled: true },
                        { key: 'channels', label: 'Channels',  disabled: false },
                        // { key: 'history', label: 'History' },
                      ].map(({ key, label,  disabled }) => (
                         <button key={key}
                          className={`border-0 bg-transparent fw-semibold px-3 pb-2 position-relative ${
                            viewMode === key ? 'text-primary' : 'text-muted'
                          } ${disabled ? 'text-muted opacity-50 cursor-default' : 'cursor-pointer'}`}
                          style={{
                            fontSize: '0.85rem',
                            borderBottom: viewMode === key ? '3px solid #0d6efd' : '3px solid transparent',
                            transition: 'all 0.3s ease',
                            pointerEvents: disabled ? 'none' : 'auto',
                          }}
                          disabled={disabled}
                          onClick={() => {
                            if (!disabled) setViewMode(key as typeof viewMode);
                            if (viewMode !== "edit") handleProductTextInformationDiscard();
                          }}
                        >
                          {label}
                        </button>
                    ))}
                  </div>

                    { viewMode === "edit" && selectedBaseItem && (
                      <> 

                      <div className="d-flex align-items-center justify-content-between border-bottom mb-2">
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder" style={{ paddingLeft: "4px" }}>
                          Product Information:
                        </h6>
                      </div>

                      <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                         <label htmlFor="productName" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Name</label>
                         <input className="form-control" type="text" name="name" value={formDataNameAndDesc.name} onChange={(e) => handleOnChange(e, "name&description")} disabled/>
                      </div>


                      <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                         <label htmlFor="productGroupName" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Group Name</label>
                         <input className="form-control" type="text" name="group_name" value={formDataNameAndDesc.group_name} onChange={(e) => handleOnChange(e, "name&description")} />
                      </div>

                      <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                         <label htmlFor="productSlug" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Slug</label>
                         <input className="form-control" type="text" name="slug" value={selectedBaseItem?.slug ?? ""} disabled />
                      </div>

                 
                      {/* <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                        <label htmlFor="productDescription" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Description</label>
                        <textarea className="form-control" name="description" value={formDataNameAndDesc.description} onChange={(e) => handleOnChange(e, "name&description")} rows={6} placeholder="Write a detailed description..."/>
                      </div> */}

                      
                       <div className="editor-container">
                        <label className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Description</label>

                        <div className="editor-preview-wrapper">
                          {/* Editor Column */}
                          <div className="editor-column">
                            <div className="editor-header">
                              <span>Current View</span>
                              <div className="toolbar">
                                {["html"].map((lang) => (
                                  <button key={lang} onClick={() => setLanguage(lang)} className={`toolbar-button ${language === lang ? "active" : ""}`}>
                                    {lang.toUpperCase()}
                                  </button>
                                ))}
                                {["vs-light", "vs-dark"].map((th) => (
                                  <button key={th} onClick={() => setTheme(th)} className={`toolbar-button ${theme === th ? "active" : ""}`}>
                                    {th === "vs-light" ? "Light" : "Dark"}
                                  </button>
                                ))}
                              </div>
                            </div>

                            <div className="editor-wrapper">
                              <Editor
                                height="400px"
                                language={language}
                                theme={theme}
                                value={formDataNameAndDesc.description}
                                onChange={(value) =>
                                  handleOnChange(value || "", "name&description", "description")
                                }
                                options={{
                                  wordWrap: "on",
                                  minimap: { enabled: false },
                                  fontSize: 14,
                                  fontFamily: "Fira Code, monospace",
                                  lineNumbers: "on",
                                  renderLineHighlight: "all",
                                  scrollBeyondLastLine: false,
                                  automaticLayout: true,
                                  tabSize: 2,
                                  insertSpaces: true,
                                  folding: true,
                                  renderWhitespace: "boundary",
                                  padding: {
                                    top: 12,
                                    bottom: 12,
                                  },
                                }}
                              />
                            </div>
                          </div>

                          {/* Preview Column */}
                          <div className="preview-column">
                            <div className="preview-header">Preview</div>
                            <div className="iframe-wrapper">
                              <iframe
                                ref={iframeRef}
                                title="Live HTML Preview"
                                sandbox="allow-same-origin allow-scripts"
                                srcDoc={formDataNameAndDesc.description}
                              />
                            </div>
                          </div>
                        </div>
                      </div>


                      <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom" style={{ paddingLeft: "4px" }}>
                         Product Image Information:
                      </h6>

                     <div className="mb-4 mt-2" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: "1px solid #e1e5ec" }}>
                      <label className="form-label fw-semibold" style={{ paddingLeft: "1.9rem" }}>Base Product Images</label>
                        
                        <div style={{margin: "0px 20px"}}>
                            {formDataNameAndDesc.product_base_assets && formDataNameAndDesc.product_base_assets.length > 0 && 
                            <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                              <SortableContext items={formDataNameAndDesc.product_base_assets} strategy={horizontalListSortingStrategy}>
                                <div style={{ display: "flex", overflowX: "auto", padding: "10px", whiteSpace: "nowrap" }}>
                                  { formDataNameAndDesc.product_base_assets.map((asset, index) => ( 
                                      <div key={asset.id} onClick={() => { setCarouselIndex(index); setIsProductImageModalOpen(true); }} style={{ cursor: "pointer" }}>
                                      <SortableBaseProductImages 
                                        key={asset.id} 
                                        asset={asset} 
                                        publicAssetsUrl={publicAssetsUrl} 
                                        selectedBaseItem={selectedBaseItem}
                                        onRemove={handleRemoveProductBaseImage} 
                                      /> 
                                     </div>
                                  ))}
                                </div>
                              </SortableContext>
                            </DndContext>
                            }
                            <hr  style={{margin: "0px 10px"}} />
                            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", margin: "10px 0", padding: "0 10px" }}>
                              <div style={{ display: "flex", gap: "8px" }}></div>
                              <span style={{ fontSize: "12px" }}>
                                Total Base Images: <b>{formDataNameAndDesc.product_base_assets.length}</b>
                              </span>
                            </div>
                            <hr style={{ margin: "0px 10px" }} />
                      </div>
                      
         
                      <small className="d-block mt-2" style={{marginLeft: "28px", color: "#494a49"}}>
                        You can upload a new image to be added to base products images.
                      </small>
                      {previewImages.length > 0 && <>
                      
                      <div className=" d-flex align-items-start gap-3 mt-2" style={{marginLeft: "28px", }}> 
                       {previewImages.map((item, idx) => {
                        const isVideo = typeof item === "string" && item.startsWith("data:video");
                        const isImage = typeof item === "string" && item.startsWith("data:image");
                        const isDocument = !isImage && !isVideo;

                        return (
                          <div key={idx} className="sa-upload-preview">
                            {isImage && <img src={item} alt={`Preview ${idx + 1}`} />}
                            {isVideo && <video src={item}  autoPlay
                              loop
                              muted
                              playsInline
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }} />}
                             

                             {isDocument && (
                              <div className="sa-upload-file-preview" title={item}>
                                {item.toLowerCase().endsWith(".pdf") ? (
                                  // PDF Icon (Red)
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="48" height="48">
                                    <rect x="6" y="2" width="52" height="60" rx="4" ry="4" fill="#E53E3E" />
                                    <polygon fill="#fff" points="50,2 58,10 50,10"/>
                                    <text x="32" y="38" fontSize="20" fill="white" fontWeight="bold" textAnchor="middle" alignmentBaseline="middle">
                                      PDF
                                    </text>
                                  </svg>
                                ) : item.toLowerCase().endsWith(".doc") || item.toLowerCase().endsWith(".docx") ? (
                                  // Word Icon (Blue)
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="48" height="48">
                                    <rect x="6" y="2" width="52" height="60" rx="4" ry="4" fill="#3182CE" />
                                    <polygon fill="#fff" points="50,2 58,10 50,10"/>
                                     <text x="32" y="38" fontSize="20" fill="white" fontWeight="bold" textAnchor="middle" alignmentBaseline="middle">
                                      W
                                    </text>
                                  </svg>
                                ) : (
                                  // Default File Icon (Gray)
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="48" height="48">
                                    <rect x="6" y="2" width="52" height="60" rx="4" ry="4" fill="#A0AEC0" />
                                    <polygon fill="#fff" points="50,2 58,10 50,10" />
                                    <text x="32" y="38" fontSize="20" fill="white" fontWeight="bold" textAnchor="middle" alignmentBaseline="middle">
                                      DOC
                                    </text>
                                  </svg>
                                )}
                              </div>
                            )}

                            <button
                              type="button"
                              onClick={() => {
                                setPreviewImages((prev) => prev.filter((_, i) => i !== idx))
                                setSelectedResourceFiles((prev) => prev.filter((_, i) => i !== idx))
                              }}
                            >
                              <span className="sa-upload-preview-close">×</span>
                            </button>
                          </div>
                        );
                      })}
                      </div>
                       <hr  style={{margin: "10px 28px"}} />
                         <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <div style={{ display: "flex", gap: "8px" }}></div>

                          <span style={{ marginRight: "28px", fontSize: "12px" }}>
                            Total Resources To Upload: <b>{previewImages.length}</b>
                          </span>
                        </div>
                        <hr  style={{margin: "10px 28px"}} />
                      </>}
                        
                       
                         
                      <div className="mt-2 d-flex align-items-start gap-3 " style={{marginLeft: "28px"}}>
                            {/* Select New Images Input Field */}
                        <label htmlFor="upload-image" className="sa-upload-select">
                          <div className="sa-upload-content">
                            <Plus size={24} color="#3e403f" />
                          </div>
                          { /* ,video/*,.pdf,.doc,.docx */ }
                          <input id="upload-image" type="file"  accept="image/*" multiple
                           onChange={(e) => {
                              const files = Array.from(e.target.files || []);
                              
                              // Update selectedFiles state
                              setSelectedResourceFiles((prev) => [...prev, ...files]);

                              files.forEach((file) => {
                                if (file.type.startsWith("image/") || file.type.startsWith("video/")) {
                                  const reader = new FileReader();
                                  reader.onloadend = () => {
                                    setPreviewImages((prev) => [...prev, reader.result as string]);
                                  };
                                  reader.readAsDataURL(file);
                                } else {
                                  // For docs: just store a placeholder string with filename
                                  setPreviewImages((prev) => [...prev, file.name]);
                                }
                              });
                            }}
                          />
                        </label>

                        { /* Save Upload Files */ }
                        {previewImages.length > 0 && (
                          <div className="sa-upload-image" title="Save all uploads" onClick={handleSubmitResourceFiles}>
                              <div className="sa-upload-content">
                                <small>Save</small>
                              </div>
                          </div>
                        )}

                      </div>
                   
                       

               
                    
                    
                    </div>

                    <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom" style={{ paddingLeft: "4px" }}>
                      Product Varaint Information:
                    </h6>


                    <div className="mb-3 mt-2" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem", border: "1px solid #e1e5ec"}}>
                       <div className="d-flex justify-content-between align-items-center mb-2">
                        <label className="form-label fw-semibold mb-0" style={{ paddingLeft: "1.7rem" }}>Product Variants</label>
                        <div className="d-flex justify-content-end align-items-center mb-2">
                          <label className="form-label me-2 mb-0 fw-semibold text-muted">
                            Filter Variants:
                          </label>
                          <div className="btn-group btn-group-sm shadow-sm" role="group" aria-label="Variant filter">
                            <button
                              type="button"
                              className={`btn btn-outline-secondary ${variantFilter === 'all' ? 'active' : ''}`}
                              onClick={() => setVariantFilter('all')}
                            >
                              <i className="bi bi-collection me-1"></i> All
                            </button>
                            <button
                              type="button"
                              className={`btn btn-outline-secondary ${variantFilter === 'open' ? 'active' : ''}`}
                              onClick={() => setVariantFilter('open')}
                            >
                              <i className="bi bi-box-seam me-1"></i> Enabled
                            </button>
                            <button
                              type="button"
                              className={`btn btn-outline-secondary ${variantFilter === 'closed' ? 'active' : ''}`}
                              onClick={() => setVariantFilter('closed')}
                            >
                              <i className="bi bi-x-circle me-1"></i> Disabled
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="mb-0" style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.775rem"}}>
                               <thead>
                                <tr style={{ color: "#6c757d" }}>
                                  <th style={{ width: "70px", ...cellStyleImage }}>Image</th>
                                  <th style={cellStyle}>Name</th>
                                  <th style={cellStyle}>SKU</th>
                                  {selectedBaseItem.opts.map((column_name, i) => (
                                    <th key={i} style={cellStyle}>
                                      {column_name.charAt(0).toUpperCase() + column_name.slice(1)}
                                    </th>
                                  ))}
                                  <th style={{ width: "150px", ...cellStyle }}>Price</th>
                                  <th style={{ width: "50px", ...cellStyle }}></th>
                                </tr>
                              </thead>
                              <tbody>
                        
                                    {filteredVariants && filteredVariants.map((variant) => (
                                    <React.Fragment key={variant.id}>
                                      <tr key={variant.id}>
                                        <td style={{ paddingTop: "0.75rem", ...defaultTdStyle}} >
                                          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                            {/* Left Arrow */}
                                            <button
                                              onClick={() =>
                                                setCarouselIndexes((prev) => ({
                                                  ...prev,
                                                  [variant.id]: Math.max((prev[variant.id] || 0) - 1, 0),
                                                }))
                                              }
                                              disabled={
                                                !Array.isArray(variant.product_base_assets) ||
                                                (carouselIndexes[variant.id] || 0) === 0
                                              }
                                              style={{
                                                background: "none",
                                                border: "none",
                                                fontSize: "16px",
                                                cursor:
                                                  !Array.isArray(variant.product_base_assets) || (carouselIndexes[variant.id] || 0) === 0
                                                    ? "not-allowed"
                                                    : "pointer",
                                                opacity:
                                                  !Array.isArray(variant.product_base_assets) || (carouselIndexes[variant.id] || 0) === 0
                                                    ? 0.3
                                                    : 1,
                                                padding: "0 4px",
                                              }}
                                            >
                                              ‹
                                            </button>

                                            {/* Image Container */}
                                            <div
                                              style={{
                                                width: "60px",
                                                height: "60px",
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                                border: "1px solid #ddd",
                                                backgroundColor: "#f9f9f9",
                                              }}
                                              onClick={() => { handleNavigateToProductVariant(variant, selectedBaseItem) }}
                                            >
                                              {Array.isArray(variant.product_base_assets) &&
                                              variant.product_base_assets[carouselIndexes[variant.id] || 0] ? (
                                                <img
                                                  src={`${publicAssetsUrl}${variant.product_base_assets[carouselIndexes[variant.id] || 0].url}`}
                                                  alt="Variant"
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    transition: "transform 0.3s ease",
                                                  }}
                                                  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                                                  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                                  onError={(e) => (e.currentTarget.style.display = "none")}
                                                />
                                              ) : (
                                                <div
                                                  style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#ccc",
                                                    fontSize: "12px",
                                                    textAlign: "center",
                                                    padding: "4px",
                                                  }}
                                                >
                                                  No image
                                                </div>
                                              )}
                                            </div>

                                            {/* Right Arrow */}
                                            <button
                                              onClick={() =>
                                                setCarouselIndexes((prev) => ({
                                                  ...prev,
                                                  [variant.id]: Math.min(
                                                    (prev[variant.id] || 0) + 1,
                                                    (variant.product_base_assets?.length || 1) - 1
                                                  ),
                                                }))
                                              }
                                              disabled={
                                                !Array.isArray(variant.product_base_assets) ||
                                                (carouselIndexes[variant.id] || 0) >= variant.product_base_assets.length - 1
                                              }
                                              style={{
                                                background: "none",
                                                border: "none",
                                                fontSize: "16px",
                                                cursor:
                                                  !Array.isArray(variant.product_base_assets) ||
                                                  (carouselIndexes[variant.id] || 0) >= variant.product_base_assets.length - 1
                                                    ? "not-allowed"
                                                    : "pointer",
                                                opacity:
                                                  !Array.isArray(variant.product_base_assets) ||
                                                  (carouselIndexes[variant.id] || 0) >= variant.product_base_assets.length - 1
                                                    ? 0.3
                                                    : 1,
                                                padding: "0 4px",
                                              }}
                                            >
                                              ›
                                            </button>
                                          </div>
                                        </td>

                                        {/* Name with badge */}
                                        <td style={{ paddingTop: "0.75rem", position: "relative", ...defaultTdStyle}}>
                                          {variant.is_closed && (
                                            <span
                                              className="badge"
                                              title="This item is disabled"
                                              style={{
                                                position: "absolute",
                                                top: "8px",
                                                right: "12px",
                                                fontSize: "0.65rem",
                                                borderRadius: "6px",
                                                padding: "4px 4px 2px 4px",
                                                backgroundColor: "#f72832",
                                                zIndex: 2,
                                              }}
                                            >
                                              Disabled
                                            </span>
                                          )}
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Variant name"
                                            title={variant.name}
                                            value={variant.name}
                                            disabled
                                          />
                                        </td>

                                        {/* SKU */}
                                        <td style={{ paddingTop: "0.75rem", ...defaultTdStyle}} >
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="SKU"
                                            title={variant.sku}
                                            value={variant.sku}
                                            disabled
                                          />
                                        </td>

                                        {/* Options */}
                                        {selectedBaseItem.opts.map((column_name) => (
                                          <td key={column_name} style={{ paddingTop: "0.75rem", ...defaultTdStyle}}>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={variant.opts[column_name] || ""}
                                              disabled
                                              title={variant.opts[column_name] || ""}
                                            />
                                          </td>
                                        ))}

                                        {/* Price */}
                                        <td style={{ paddingTop: "0.75rem", ...defaultTdStyle}}>
                                           <input
                                            type="text"
                                            inputMode="decimal"
                                            className="form-control"
                                            title={`R ${variant.price}`}
                                            placeholder="0.00"
                                            value={variant.price}
                                            disabled
                                          />
                                        </td>
                                         <td style={{ paddingTop: "0.75rem", position: "relative", ...defaultTdStyle}} >
                                            <button title="Locations" style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: '6px', borderRadius: '6px', transition: 'background 0.2s ease-in-out'}}
                                              onMouseOver={(e) => {
                                                (e.currentTarget.style.background = '#f0f0f0'); // subtle hover effect
                                              }}
                                              onMouseOut={(e) => {
                                                (e.currentTarget.style.background = 'transparent');
                                              }}
                                               onClick={() =>
                                                  setExpandedLocations(prev => ({
                                                    ...prev,
                                                    [variant.id]: !prev[variant.id],
                                                  }))
                                                }
                                             >
                                              {expandedLocations[variant.id] && <ChevronUp/>}
                                              {!expandedLocations[variant.id] && <ChevronDown/>} 
                                            </button>
                                          </td>
                                      </tr>
                                      {expandedLocations[variant.id] && (
                                      <tr>
                                        <td colSpan={5 + selectedBaseItem.opts.length} style={{ padding: "0px 60px 0px 118px", border: "none"}}>
                                          {variant.locations?.length ? (
                                            <table className="table table-bordered mb-0" style={{ fontSize: "0.75rem" }}>
                                              <thead>
                                                <tr >
                                                  <th>Code</th>
                                                  <th>Name</th>
                                                  <th>In Stock</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {variant.locations.map((loc) => (
                                                  <tr key={loc.id}>
                                                    <td>{loc.code}</td>
                                                    <td>{loc.name}</td>
                                                    <td>{loc.in_stock}</td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                            </table>
                                          ) : (
                                             <center>
                                               <div style={{ fontStyle: "italic", color: "#888", fontSize: "12px", border: '1px solid #dee2e6' }}>No location data...</div>
                                             </center>
                                          )}
                                        </td>
                                      </tr>
                                    )}
                                    </React.Fragment>
                                  ))}

                          </tbody>
                        </table>
                      </div>
                     
                    </div>
                    </>
                    )}

                    
                     { viewMode === "seo" && selectedBaseItem && (
                      <>

                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom mb-2" style={{ paddingLeft: "4px" }}>
                          Product Information:
                        </h6>

                       
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Product Name</label>
                          <input type="text" className="form-control" value={selectedBaseItem.name} id="productTitle" placeholder="Enter product name" disabled />
                        </div>

                      
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productDescription" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Description</label>
                          <textarea className="form-control" value={selectedBaseItem?.description ?? ''} id="productDescription" rows={6} placeholder="Write a detailed description..."  disabled/>
                        </div>

                       
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom mb-2" style={{ paddingLeft: "4px" }}>
                          SEO Information:
                        </h6>

                         
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Meta Tag Title</label>
                          <input type="text" className="form-control"  placeholder="Enter product meta tag title" disabled />
                        </div>

                         
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productDescription" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Meta Tag Description</label>
                          <textarea className="form-control" rows={6} placeholder="Write a detailed meta tag description..."  disabled/>
                        </div>

                       
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productDescription" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Meta Tag Keywords</label>
                          <textarea className="form-control"  rows={6} placeholder="Write a detailed meta tag keywords..."  disabled/>
                        </div>

                      
                        <p className="text-muted" style={{ paddingLeft: "1.6rem" }}><b>Suggest Url Slug:</b> {`${slugifyNameForUrl(selectedBaseItem.name)}`}</p>
                        
                        <div className="mb-3" style={{ backgroundColor: "#f9f9f9", padding: "1rem", borderRadius: "0.5rem",  border:'1px solid #e1e5ec' }}>
                          <label htmlFor="productTitle" className="form-label fw-semibold" style={{ paddingLeft: "0.75rem" }}>Url Slug</label>
                          <input type="text" className="form-control"  placeholder="Enter url slug" disabled />
                          <p style={{ paddingLeft: "0.75rem" }} className="text-muted d-block mt-2">A URL slug is the last part of the URL address that serves as a unique identifier of the page.</p>
                        </div>
                      </>
                    )} 
                     
                      { viewMode === "channels" && selectedBaseItem && (
                      <>
                       <div className="mb-4">
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom" style={{ paddingLeft: "4px" }}>
                          Channel Status Overview:
                        </h6>

                        <div className="table-responsive bg-white p-1 rounded shadow-sm border mt-2">
                          <table className="table table-sm align-middle mb-0">
                            <thead className="bg-light text-muted">
                              <tr>
                                <th style={{ background: "rgb(41, 48, 66)", color: "white" }}>Channel</th>
                                <th style={{ background: "rgb(41, 48, 66)", color: "white" }}>Status</th>
                                <th style={{ background: "rgb(41, 48, 66)", color: "white" }}>Toggle</th>
                                <th style={{ width: "300px",  background: "rgb(41, 48, 66)", color: "white" }}> Variant Actions</th>
                              </tr>
                            </thead>
                             <tbody>
                                { selectedBaseItem.channels?.map(({ id, code, is_enabled, num_variants}) => {
                                  return (
                                    <tr key={id} >
                                       <td>{code}</td>
                                        <td>
                                           <span className={`badge ${is_enabled ? "bg-success" : "bg-secondary"}`}>
                                            {is_enabled ? "ENABLED" : "DISABLED"}
                                          </span>
                                        </td>
                                        <td>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input different"
                                              type="checkbox"
                                              id={id}
                                              checked={is_enabled}
                                              onChange={() => handleToggleChannel(selectedBaseItem.id, id, !is_enabled)}
                                            />
                                          </div>
                                        </td>
                                        <td style={{ display: 'flex', gap: '10px',  }}>
                                          {/* Select All Button */}
                                          <button
                                           // onClick={handleSelectAll} // your handler
                                            style={{
                                              padding: '2px 14px',
                                              borderRadius: '20px',
                                              border: '1px solid rgba(0,0,0,0.15)',
                                              // background: '#fff',
                                              background: num_variants === selectedBaseItem.num_variants ? '#e8e8e8' : '#fff',
                                              color: '#333',
                                              fontSize: '14px',
                                              fontWeight: 500,
                                              cursor: num_variants === selectedBaseItem.num_variants ? 'default' : 'pointer',
                                              transition: 'background 0.2s ease, border-color 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => { if (num_variants !== selectedBaseItem.num_variants) (e.currentTarget.style.background = '#f0f0f0')}}
                                            onMouseLeave={(e) => {if (num_variants !== selectedBaseItem.num_variants) (e.currentTarget.style.background = '#fff')}}
                                            disabled={num_variants === selectedBaseItem.num_variants}
                                            onClick={() => handleEnablingProductVariantSelection(selectedBaseItem.id, id, true) }
                                          >
                                            Select All
                                          </button>

                                          {/* Deselect All Button */}
                                          <button
                                            //onClick={handleDeselectAll} // your handler
                                            style={{
                                              padding: '2px 14px',
                                              borderRadius: '20px',
                                              border: '1px solid rgba(0,0,0,0.15)',
                                              background: num_variants === 0 ? '#e8e8e8' : '#fff',
                                              color: '#333',
                                              fontSize: '14px',
                                              fontWeight: 500,
                                              cursor: num_variants === 0 ? 'default' : 'pointer',
                                              transition: 'background 0.2s ease, border-color 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => { if (num_variants !== 0) e.currentTarget.style.background = '#f0f0f0';}}
                                            onMouseLeave={(e) => { if (num_variants !== 0) e.currentTarget.style.background = '#fff'; }}
                                            disabled={num_variants === 0}
                                            onClick={() => handleEnablingProductVariantSelection(selectedBaseItem.id, id, false) }
                                          >
                                            Deselect All
                                          </button>
                                        </td>
                                    </tr>
                                   );
                                 })}

                              </tbody>
                          </table>
                        </div>
                      </div>
                      {/* <div>
                        <h6 className="modal-title text-uppercase text-secondary fw-bolder border-bottom" style={{ paddingLeft: "4px" }}>
                             Channel Settings:
                        </h6>
                        <div className="d-flex flex-column flex-md-row gap-4 mt-2">
                            <div className="d-flex flex-md-column border-bottom border-top border-md-0 border-end pe-md-4 gap-2 gap-md-0"
                                style={{ minWidth: "180px", flexShrink: 0 }}
                              >
                               {[
                                { key: "channel one", label: "Amazon", hasAccess: true },
                                { key: "channel two", label: "Google Merchant Center", hasAccess: false },
                                { key: "channel three", label: "Shopify", hasAccess: true },
                                { key: "channel four", label: "Takealot", hasAccess: true },
                                { key: "channel five", label: "WooCommerce", hasAccess: false },
                              ]
                                .filter(({ hasAccess }) => hasAccess)
                                .map(({ key, label }) => {
                                  const isActive = channelView === key;
                                  return (
                                    <button
                                      key={key}
                                      className={`border-0 bg-transparent fw-semibold px-3 py-2 text-start position-relative w-100 ${
                                        isActive ? "text-primary" : "text-muted"
                                      }`}
                                      style={{
                                        fontSize: "0.85rem",
                                        borderLeft: isActive ? "3px solid #0d6efd" : "3px solid transparent",
                                        backgroundColor: isActive ? "#f8f9fa" : "transparent",
                                        transition: "all 0.3s ease",
                                      }}
                                      onClick={() => setChannelView(key)}
                                    >
                                      {label}
                                    </button>
                                  );
                                })}
                              </div>

                      
                          <div className="flex-grow-1">
                            {channelView === "channel one" && <p>Amazon content goes here...</p>}
                            {channelView === "channel two" && <div>
                                  <p>Google Merchant Center content goes here...</p>
                             </div>
                            }
                            {channelView === "channel three" && <p>Shopfiy content goes here...</p>}
                            {channelView === "channel four" && <p>Takealot content goes here...</p>}
                            {channelView === "channel five" && <p>WooCommerce content goes here...</p>}
                          </div>
                        </div>
                        </div> */}
                      </>
                    )} 

                  { /* 
                   { viewMode === "history" && selectedBaseItem && (
                      <>
                         <p className="text-muted mb-4" style={{paddingLeft: "4px"}}>You are in product history mode...</p>
                      </>
                    )}  */}
                  </Card.Body>
                </Card>
                </>
                } 

              
          {isImportModalOpen && (
              <div className="modal d-block" tabIndex={-1} onClick={() => setIsImportModalOpen(false)} style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                  <div className="modal-content position-relative">
                    <div className="modal-header">
                      <h5 className="modal-title text-uppercase text-secondary fw-bolder ">
                            Import Product List: 
                      </h5>
                      <button type="button" className="btn-close"
                        onClick={() => {
                          setIsImportModalOpen(false);
                        }}
                      />
                    </div>
                     <div className="modal-body d-flex flex-column align-items-center gap-3">
                        <input type="file" className="form-control" accept=".xlsx,.csv" onChange={handleFileChange}/>
                        {selectedFile && ( <p className="text-muted small"> Selected file: <strong>{selectedFile.name}</strong></p>)}
                      </div>
                      <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={() => setIsImportModalOpen(false)}>
                          Cancel
                        </button>
                        <button className="btn btn-primary" disabled={!selectedFile} onClick={handleFileImportSubmit}>
                          Upload File
                        </button>
                      </div>
                  </div>
                </div>
              </div>
          )}


              
          {isImageModalOpen && (
            <div className="modal d-block modal-images-gallery-carousel" tabIndex={-1} onClick={() => handleCloseAndResetModal("default-gallery")}>
              <div className="modal-dialog modal-xl modal-dialog-centered images-gallery-carousel-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content position-relative images-gallery-carousel-inner">
                  {/* HEADER */}
                  <div className="modal-header border-0 pb-2 pt-3 px-4 header-content">
                    <h5 className="modal-title fw-semibold mb-0 header-title">
                      <span className="title">Product</span>
                      <span className="product">{selectedProduct}</span>
                    </h5>
                    <button type="button" className="close-gallery-btn"
                      onClick={() => handleCloseAndResetModal("default-gallery")}
                    >
                      ✕
                    </button>
                  </div>
                  {/* Image Count */}
                  <div className="image-count">
                    {selectedImages.length} image{selectedImages.length !== 1 ? 's' : ''}
                  </div>
                  {/* BODY */}
                  <div className="modal-body d-flex flex-column align-items-center body-content">
                    <div className="d-flex justify-content-center align-items-center body-content-inner">
                      {/* LEFT ARROW */}
                      {selectedImages.length > 1 && (
                        <button className={`image-carousel-left-btn ${carouselBaseImagesIndex === 0 ? 'inactive' : ''}`}
                          onClick={() => setCarouselBaseImagesIndex((prev) => Math.max(prev - 1, 0))}
                          disabled={carouselBaseImagesIndex === 0}
                        >
                          ‹
                        </button>
                      )}
                      {/* IMAGES */}
                      <div className="image-gallery-carousel">
                        {selectedImages.slice(carouselBaseImagesIndex, carouselBaseImagesIndex + 3).map((url, idx) => (
                          <div className="image-container" key={carouselBaseImagesIndex + idx}>
                            <img className="carousel-image" src={`${publicAssetsUrl}${url}`} alt={`img-${carouselBaseImagesIndex + idx}`}/>
                          </div>
                        ))}
                      </div>
                      {/* RIGHT ARROW */}
                      {selectedImages.length > 1 && (
                        <button className={`image-carousel-right-btn ${carouselBaseImagesIndex >= selectedImages.length - 3 ? 'inactive' : ''}`}
                          onClick={() => setCarouselBaseImagesIndex((prev) => Math.min(prev + 1, selectedImages.length - 3))}
                          disabled={carouselBaseImagesIndex >= selectedImages.length - 3}
                        >
                          ›
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          
          {isProductImageModalOpen && viewMode === "edit" && (
            <div className="modal d-block modal-images-gallery-carousel" tabIndex={-1} onClick={() => handleCloseAndResetModal("edit-gallery")}>
              <div className="modal-dialog modal-xl modal-dialog-centered images-gallery-carousel-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content position-relative images-gallery-carousel-inner">
                  {/* HEADER */}
                  <div className="modal-header border-0 pb-2 pt-3 px-4 header-content">
                     <h5 className="modal-title fw-semibold mb-0 header-title">
                      <span className="title">Product</span>
                      <span className="product">{selectedBaseItem?.name}</span>
                    </h5>
                     <button className="close-gallery-btn" type="button" onClick={() => handleCloseAndResetModal("edit-gallery")}>
                      ✕
                     </button>
                  </div>
                  {/* IMAGE COUNT */}
                  <div className="image-count">
                    {formDataNameAndDesc.product_base_assets.length} image{formDataNameAndDesc.product_base_assets.length !== 1 ? "s" : ""}
                  </div>
                  {/* BODY */}
                  <div className="modal-body d-flex flex-column align-items-center body-content">
                    <div className="d-flex justify-content-center align-items-center body-content-inner">
                      {/* LEFT ARROW */}
                      {formDataNameAndDesc.product_base_assets.length > 1 && (
                        <button className={`image-carousel-left-btn ${carouselIndex === 0 ? 'inactive' : ''}`}
                          onClick={() => setCarouselIndex((prev) => Math.max(prev - 1, 0))}
                          disabled={carouselIndex === 0}
                        >
                          ‹
                        </button>
                      )}
                      {/* IMAGES */}
                      <div className="image-gallery-carousel">
                        {formDataNameAndDesc.product_base_assets.slice(carouselIndex, carouselIndex + 3).map((asset, idx) => (
                          <div className="image-container" key={asset.id}>
                            <img className="carousel-image" src={`${publicAssetsUrl}${asset.url}`} alt={`img-${carouselIndex + idx}`}/>
                          </div>
                        ))}
                      </div>
                      {/* RIGHT ARROW */}
                      {formDataNameAndDesc.product_base_assets.length > 1 && (
                        <button
                          className={`image-carousel-right-btn ${carouselIndex >= formDataNameAndDesc.product_base_assets.length - 3 ? 'inactive' : ''}`}
                          onClick={() => setCarouselIndex((prev) => Math.min(prev + 1, formDataNameAndDesc.product_base_assets.length - 3))}
                          disabled={carouselIndex >= formDataNameAndDesc.product_base_assets.length - 3}
                        >
                          ›
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}


            </Container>
        </React.Fragment>
    );
}

